import Cookies from "js-cookie";
import axios from "axios";
import {
  push
} from "connected-react-router";
import {
  DOMAIN
} from "../utils/constant";

export const AUTH_REGISTER_REQUEST = "AUTH_REGISTER_REQUEST";
export const AUTH_REGISTER_SUCCESS = "AUTH_REGISTER_SUCCESS";
export const AUTH_REGISTER_FAIL = "AUTH_REGISTER_FAIL";
export const register = (
  name,
  pseudonym,
  email,
  phone,
  subscription,
  password,
  password_confirmation
) => dispatch => {
  dispatch({
    type: AUTH_REGISTER_REQUEST
  });
  axios
    .request({
      url: "auth/register",
      method: "POST",
      data: {
        name,
        pseudonym,
        email,
        phone,
        subscription,
        password,
        password_confirmation
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: AUTH_REGISTER_SUCCESS,
          msg: data.message,
          data: data.data
        });
        Cookies.set("access_token", data.data.access_token, {
          expires: 365
        });
        Cookies.set("expires_in", data.data.expires_in, {
          expires: 365
        });
        dispatch(push("/dash/users"));
      } else {
        dispatch({
          type: AUTH_REGISTER_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {},
          data: data.data
        });
      }
    });
};

export const AUTH_LOGIN_REQUEST = "AUTH_LOGIN_REQUEST";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAIL = "AUTH_LOGIN_FAIL";
export const login = (email, password) => dispatch => {
  dispatch({
    type: AUTH_LOGIN_REQUEST
  });
  axios
    .request({
      url: "auth/login",
      data: {
        email: email,
        password: password
      },
      method: "post"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: AUTH_LOGIN_SUCCESS,
          msg: data.message,
          profile: data.data
        });
        Cookies.set("access_token", data.data.token.access_token, {
          expires: 365
        });
        Cookies.set("expires_in", data.data.token.expires_in, {
          expires: 365
        });
        if (data.data.user.role.id < 600) {
          dispatch(push("/dash/admin/users"));
          console.log("admin");
        } else {
          dispatch(push("/dash/user/profile"));
          console.log("user");
        }
        // let redirectTo = Cookies.get("lastPage", "");
        // if (redirectTo) {
        //   Cookies.remove("lastPage");
        //   window.location.href = redirectTo;
        // } else {
        //   dispatch(push("/users"));
        // }
      } else {
        dispatch({
          type: AUTH_LOGIN_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
      }
    }).catch(err => {
      dispatch({
        type: AUTH_LOGIN_FAIL,
        msg: "",
        errors: {}
      })
    });
};

export const AUTH_LOGOUT_REQUEST = "AUTH_LOGOUT_REQUEST";
export const logout = (reason) => dispatch => {
  dispatch({
    type: AUTH_LOGOUT_REQUEST
  });
  if (reason === '401') {
    Object.keys(Cookies.get()).forEach(function (cookie) {
      Cookies.remove(cookie);
    });
    // Cookies.remove("_session");
    // Cookies.remove("access_token");
    // Cookies.remove("expires_in");
    if (!window.location.href.includes("/dash/auth/login")) {
      Cookies.set("lastPage", window.location.href);
    }
    dispatch(push("/dash/auth/login"));
    return
  }
  axios
    .request({
      url: "auth/logout",
      method: "POST",
      params: {}
    })
    .then(({
      data
    }) => {
      if (data.success) {
        console.log('logout!')
        Object.keys(Cookies.get()).forEach(function (cookie) {
          Cookies.remove(cookie);
        });
        // Cookies.remove("_session");
        // Cookies.remove("access_token");
        // Cookies.remove("expires_in");
        // if (!window.location.href.includes("/dash/auth/login")) {
        //   Cookies.set("lastPage", window.location.href);
        // }
        console.log(DOMAIN)
        window.location.href = DOMAIN + '?logout=true';
        // dispatch(push("/dash/auth/login"));
      }
    });

};

export const AUTH_GET_PROFILE_REQUEST = "AUTH_GET_PROFILE_REQUEST";
export const AUTH_GET_PROFILE_SUCCESS = "AUTH_GET_PROFILE_SUCCESS";
export const AUTH_GET_PROFILE_FAIL = "AUTH_GET_PROFILE_FAIL";
export const getProfile = () => dispatch => {
  dispatch({
    type: AUTH_GET_PROFILE_REQUEST
  });
  axios
    .request({
      url: "profile",
      method: "GET",
      params: {}
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: AUTH_GET_PROFILE_SUCCESS,
          msg: data.message,
          profile: data.data
        });
      } else {
        dispatch({
          type: AUTH_GET_PROFILE_FAIL,
          errors: data.errors ? data.errors : {},
          msg: data.message
        });
      }
    });
};

export const AUTH_FORGOT_PASSWORD_REQUEST = "AUTH_FORGOT_PASSWORD_REQUEST";
export const AUTH_FORGOT_PASSWORD_SUCCESS = "AUTH_FORGOT_PASSWORD_SUCCESS";
export const AUTH_FORGOT_PASSWORD_FAIL = "AUTH_FORGOT_PASSWORD_FAIL";
export const forgotPassword = email => dispatch => {
  dispatch({
    type: AUTH_FORGOT_PASSWORD_REQUEST
  });
  axios
    .request({
      url: "forgot-password",
      method: "POST",
      data: {
        email
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: AUTH_FORGOT_PASSWORD_SUCCESS,
          msg: data.message
        });
      } else {
        dispatch({
          type: AUTH_FORGOT_PASSWORD_FAIL,
          errors: data.errors ? data.errors : {},
          msg: data.message
        });
      }
    }).catch(err => {
      dispatch({ type: AUTH_FORGOT_PASSWORD_FAIL })
    });
};

export const AUTH_RESET_PASSWORD_REQUEST = "AUTH_RESET_PASSWORD_REQUEST";
export const AUTH_RESET_PASSWORD_SUCCESS = "AUTH_RESET_PASSWORD_SUCCESS";
export const AUTH_RESET_PASSWORD_FAIL = "AUTH_RESET_PASSWORD_FAIL";
export const resetPassword = ({
  email,
  password,
  password_confirmation,
  token
}) => dispatch => {
  dispatch({
    type: AUTH_RESET_PASSWORD_REQUEST
  });
  axios
    .request({
      url: "reset-password",
      method: "POST",
      data: {
        email,
        password,
        password_confirmation,
        token
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: AUTH_RESET_PASSWORD_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: AUTH_RESET_PASSWORD_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {},
          data: data.data
        });
      }
    }).catch(err => {
      dispatch({ type: AUTH_RESET_PASSWORD_FAIL })
    });
};

export const AUTH_CLEAR_MSG = "AUTH_CLEAR_MSG";
export const clearMsg = () => dispatch => {
  dispatch({
    type: AUTH_CLEAR_MSG
  });
};